import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import styles from './Pagination.module.scss';
import { searchToObj } from '../../utils/url';

const Pagination = ({ active, pages, baseUrl }) => {
    const [extraSearch, setExtraSearch] = useState('');

    useEffect(() => {
        const currentSearch = searchToObj();
        const searchParams = ['area', 'year']
            .filter((key) => currentSearch[key])
            .map((key) => `&${key}=${currentSearch[key]}`)
            .join('');
        setExtraSearch(searchParams);
    }, []);

    const handlePageChange = ({ selected }) => {
        const page = selected + 1;
        window.location.href = `${baseUrl}${page}${extraSearch}`;
    };

    return (
        <nav
            aria-label="pagination navigation"
            className={styles['Pagination']}>
            <ReactPaginate
                previousLabel={
                    active > 1 ? (
                        <div
                            className={
                                styles['Pagination__ToggleItemIconPrevious']
                            }>
                            <img
                                src={'/assets/svg/arrow--right-black.svg'}
                                alt="Signalisten Logotyp"
                                className="Hero__LogoIcon"
                            />
                        </div>
                    ) : null
                }
                nextLabel={
                    active < pages ? (
                        <div
                            className={
                                styles['Pagination__ToggleItemIconNext']
                            }>
                            <img
                                src={'/assets/svg/arrow--right-black.svg'}
                                alt="Signalisten Logotyp"
                                className="Hero__LogoIcon"
                            />
                        </div>
                    ) : null
                }
                breakLabel="..."
                breakClassName={styles['Pagination__Break']}
                onPageChange={handlePageChange}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pages}
                forcePage={active - 1}
                containerClassName={styles['Pagination__Ul']}
                pageClassName={styles['Pagination__Item']}
                pageLinkClassName={styles['Pagination__Link']}
                activeClassName={styles['Pagination__Item--Active']}
                previousClassName={styles['Pagination__Button--Prev']}
                nextClassName={styles['Pagination__Button--Next']}
                disabledClassName={styles['Pagination__Button--Disabled']}
            />
        </nav>
    );
};

Pagination.propTypes = {
    active: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    baseUrl: PropTypes.string.isRequired,
};

Pagination.defaultProps = {
    active: 1,
    pages: 0,
};

export default Pagination;
